<z-starting [starting]="starting"></z-starting>
<z-spinner [inProgress]="loading"></z-spinner>
<router-outlet></router-outlet>